import axios from 'axios'
import { ProxyAllowlistRequestStatus } from '@numeo/types'
import type { ProxyAllowlistRequestDto, ProxyAllowlistUrlDto } from '@numeo/types'

const BASE = '/gluon/proxy-allowlist'

export { ProxyAllowlistRequestStatus }
export type { ProxyAllowlistRequestDto, ProxyAllowlistUrlDto }

export const proxyAllowlistApi = {
    async listRequests(status?: ProxyAllowlistRequestStatus): Promise<ProxyAllowlistRequestDto[]> {
        const { data } = await axios.get<{ success: boolean; data: { requests: ProxyAllowlistRequestDto[] } }>(`${BASE}/requests`, {
            params: status ? { status } : undefined,
        })
        return data?.data?.requests ?? []
    },

    async approveRequest(requestId: string): Promise<void> {
        await axios.post(`${BASE}/requests/${requestId}/approve`)
    },

    async rejectRequest(requestId: string, reason?: string): Promise<void> {
        await axios.post(`${BASE}/requests/${requestId}/reject`, reason ? { reason } : {})
    },

    async listUrls(): Promise<ProxyAllowlistUrlDto[]> {
        const { data } = await axios.get<{ success: boolean; data: { urls: ProxyAllowlistUrlDto[] } }>(`${BASE}/urls`)
        return data?.data?.urls ?? []
    },

    async addUrl(domain: string, hidden = false): Promise<ProxyAllowlistUrlDto> {
        const { data } = await axios.post<{ success: boolean; data: { url: ProxyAllowlistUrlDto } }>(`${BASE}/urls`, { domain, hidden })
        return data.data.url
    },

    async setUrlHidden(id: string, hidden: boolean): Promise<ProxyAllowlistUrlDto> {
        const { data } = await axios.patch<{ success: boolean; data: { url: ProxyAllowlistUrlDto } }>(`${BASE}/urls/${id}`, { hidden })
        return data.data.url
    },

    async deleteUrl(id: string): Promise<void> {
        await axios.delete(`${BASE}/urls/${id}`)
    },

    // ─── Blocklist (forced-DIRECT domains; never shown to end users) ───

    async listBlocklist(): Promise<ProxyAllowlistUrlDto[]> {
        const { data } = await axios.get<{ success: boolean; data: { urls: ProxyAllowlistUrlDto[] } }>(`${BASE}/blocklist`)
        return data?.data?.urls ?? []
    },

    async addBlocklist(domain: string): Promise<ProxyAllowlistUrlDto> {
        const { data } = await axios.post<{ success: boolean; data: { url: ProxyAllowlistUrlDto } }>(`${BASE}/blocklist`, { domain })
        return data.data.url
    },

    async deleteBlocklist(id: string): Promise<void> {
        await axios.delete(`${BASE}/blocklist/${id}`)
    },
}
